<template>
  <div class="box">
    <v-server-table
      ref="datatable"
      :url="api"
      :name="tableName"
      :columns="columns"
      :options="options">
      <template slot="beforeTable">
        <datatable-loader :name="tableName"/>
      </template>
    </v-server-table>
  </div>
</template>
<script>
const TableName = 'VUETABLE_MONTHLY';
export default {
    data: function() {
        var that = this;
        return {
            tableName: TableName,
            columns: [
                'month',
                'total_pax',
                'total_receipts',
                'item_modifier',
                'discount',
                'sub_total',
                'service_charge',
                'tax',
                'total',
            ],
            options: {
                perPage: 12,
                perPageValues: [12],
                texts: {
                    title: 'Monthly Sales',
                    description: 'Shows monthly sale details',
                },
                sortable: ['month', 'total_pax', 'total_receipts'],
                useReportFilter: true,
                customFilters: ['outlet_id', 'since_year', 'until_year'],
                initFilters: {
                    outlet_id: that.$store.getters.activeOutlet,
                    since_year: that.$store.getters.startYear.format(),
                    until_year: that.$store.getters.endYear.format(),
                },
                columnsClasses: {
                    total_pax: 'text-right width-10',
                    sub_total: 'text-right width-10',
                    item_modifier: 'text-right width-10',
                    discount: 'text-right width-10',
                    tax: 'text-right width-10',
                    service_charge: 'text-right width-10',
                    total: 'text-right width-10',
                    total_receipts: 'text-right width-10',
                },
                headings: {
                    total_pax: 'Pax',
                    total_receipts: 'Total Receipts',
                    sub_total: `Sub Total`,
                    item_modifier: `Item Price Modifier`,
                    service_charge: `Service Charge`,
                    discount: `Receipt Discount`,
                    tax: `Taxes`,
                    total: `Total`,
                },
                templates: {
                    total_pax: (h, row) => {
                        return numeral(parseFloat(row.total_pax)).format('0,0');
                    },
                    total_receipts: (h, row) => {
                        return numeral(parseFloat(row.total_receipts)).format(
                            '0,0',
                        );
                    },
                    sub_total: (h, row) => {
                        return numeral(parseFloat(row.sub_total)).format();
                    },
                    item_modifier: (h, row) => {
                        return numeral(parseFloat(row.item_modifier)).format();
                    },
                    service_charge: (h, row) => {
                        return numeral(parseFloat(row.service_charge)).format();
                    },
                    tax: (h, row) => {
                        return numeral(parseFloat(row.tax)).format();
                    },
                    discount: (h, row) => {
                        return numeral(parseFloat(row.discount)).format();
                    },
                    total: (h, row) => {
                        return numeral(parseFloat(row.total)).format();
                    },
                },
                pdf_url: Laroute.route(
                    'franchise.report.monthly.exportAsFile',
                    {
                        type: 'PDF',
                    },
                ),
                csv_url: Laroute.route(
                    'franchise.report.monthly.exportAsFile',
                    {
                        type: 'CSV',
                    },
                ),
                xls_url: Laroute.route(
                    'franchise.report.monthly.exportAsFile',
                    {
                        type: 'XLSX',
                    },
                ),
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('franchise.report.monthly.index');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/monthly/vuetable_monthly.vue